import Grid from '@mui/material/Grid2'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useParams } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom'
const ButtonMenuTournament = ({ type, allowed }) => {
  const { id } = useParams()

  const navigate = useNavigate()
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  let head = ''
  let logo = ''
  let description = ''
  let access = ''
  var path = ''
  const icoaccess = allowed ? '/images/icouser.svg' : '/images/lock.svg'
  let isAccess = allowed ? true : false
  switch (type) {
    case 'Weighing':
      head = 'Взвешивание'
      logo = '/images/icowe.svg'
      description =
        'Провести взвешивание рыбы по секторам. Открыть утреннее, дневное, вечернее или дополнительное взвешивание.'
      access = 'главный судья, судья'
      path = 'weighing'
      break
    case 'Draw':
      head = 'Жеребьёвка'
      logo = '/images/icojre.svg'
      description =
        'Провести жеребьёвку. Изменить тип жеребьёвки можно в разделе настройки. Убедитесь, что все команды зарегистрированы.'
      access = 'главный судья, судья, главный секретарь, cудья - секретарь'
      path = 'draw'
      break
    case 'Commands':
      head = 'Команды'
      logo = '/images/icoteam.svg'
      description =
        'Подтвердить заявки от команд. Зарегистрировать вручную команду. Подтвердить данные спортсмена. Внести данные об оплате.'
      access =
        'организатор, главный судья, главный секретарь, cудья - секретарь'
      path = 'teams'
      break
    case 'Documentation':
      head = 'Документация'
      logo = '/images/icodocks.svg'
      description =
        'Распечатать протоколы, регламент. Сохранить пакеты документов для присвоения спортивных разрядов и другую документацию.'
      access =
        'организатор, главный судья, главный секретарь, cудья - секретарь'
      path = 'documentation'
      break
    case 'Settings':
      head = 'Настройки'
      logo = '/images/icoset.svg'
      description =
        'Изменить все имеющиеся настройки: название, тип, количество этапов, номинации, протоколы, логотип и т.д.'
      access = 'организатор, главный судья'
      path = 'settings'
      break
    case 'Access':
      head = 'Доступы'
      logo = '/images/icosec.svg'
      description =
        'Предоставить или удалить доступ к турниру для организатора, главного судьи, судьи, главного секретаря, секретаря.'
      access = 'организатор, главный судья'
      path = 'access'
      break
    case 'Social':
      head = 'Соцсети'
      logo = '/images/icosocial.svg'
      description =
        'Настроить автоматическую выгрузку в Telegram и ВКонтакте - протоколов взвешивания, каждого взвешивания.'
      access = 'организатор'
      path = 'social'
      break
    case 'Sponsors':
      head = 'Спонсоры'
      logo = '/images/icorub.svg'
      description =
        'Добавить информацию о спонсорах соревнования, настроить отображение логотипов в протоколах.'
      access =
        'организатор, главный судья, судья, главный секретарь, cудья - секретарь'
      path = 'sponsors'
      break
    default:
      break
  }
  const openCupBut = () => {
    console.log('/tournaments/' + id + '/' + path)
    if (isAccess) navigate('/tournaments/' + id + '/' + path)
  }
  return (
    <Grid size={{ xs: 12, md: 6 }} onClick={openCupBut}>
      <Item className="mainmenu">
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Box textAlign="center">
              <Box>
                <img
                  src={logo}
                  style={{ maxWidth: '50px', borderRadius: '0px' }}
                  alt="logo"
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Typography variant="h6" gutterBottom color="black">
              {head}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Box textAlign="left">
            <Typography variant="body2" gutterBottom color="black">
              {description}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Box display="flex" alignItems="center">
            <img
              src={icoaccess}
              style={{
                maxWidth: '15px',
                borderRadius: '0px',
                paddingRight: '10px',
              }}
              alt="logo"
            />
            {access}
          </Box>
        </Grid>
      </Item>
    </Grid>
  )
}

export default ButtonMenuTournament
